/**
 * "Count credits from" — popup Edit Subscription, pelanggan Flow JENIS 2 sahaja (2026-10-03).
 *
 * Borang Add customer memakai tarikh "Started" untuk DUA benda: mula langganan + mula kira credit.
 * Gmail yang pernah diguna orang lain / diuji admin sebelum diserah → pelanggan menanggung
 * penggunaan itu. Di sini admin boleh:
 *   · Change → pilih tarikh → "Reset & recount": kiraan dibuang dan dikira semula dari tarikh itu.
 *   · Recount → tarikh sama, kira semula (betulkan angka yang hanyut).
 * "Sampai bila" = tarikh Expires di sebelahnya (tiada medan kedua).
 *
 * Tulisan melalui server sahaja (`/admin/t2-kira-dari` → functions/flowT2Kredit.js tetapKiraDari);
 * rules menolak client. Server mengira semula SERTA-MERTA daripada baris credit yang sudah dibaca;
 * tarikh lebih awal daripada bacaan pertama = baris lama ditambah bila browser pelanggan membaca semula.
 */
import { useState } from 'react';
import { Btn } from '../design/ui';
import { tetapKiraDariJenis2 } from '../services/flowT2Admin';

const papar = (ms) => new Date(ms).toLocaleString('en-MY', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'Asia/Kuala_Lumpur' });
// Nilai untuk <input type="datetime-local"> dalam waktu tempatan browser admin.
const keInput = (ms) => {
    const d = new Date(ms), p = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};

export default function FlowKiraDari({ uid, kiraDari, endAt, onSaved }) {
    const [semasa, setSemasa] = useState(Number.isSafeInteger(kiraDari) && kiraDari > 0 ? kiraDari : null);
    const [ubah, setUbah] = useState(false);
    const [nilai, setNilai] = useState('');
    const [sedang, setSedang] = useState(false);
    const [ralat, setRalat] = useState('');
    const [hasil, setHasil] = useState('');

    const buka = () => { setNilai(keInput(semasa || Date.now())); setRalat(''); setHasil(''); setUbah(true); };
    const jalan = async (ms) => {
        if (!Number.isSafeInteger(ms)) { setRalat('Pick a date and time.'); return; }
        if (ms > Date.now()) { setRalat('This must not be in the future.'); return; }
        if (Number.isSafeInteger(endAt) && ms >= endAt) { setRalat('This must be before the access end date.'); return; }
        setSedang(true); setRalat(''); setHasil('');
        try {
            const r = await tetapKiraDariJenis2({ uid, kiraDari: ms });
            const guna = Number.isSafeInteger(r.dahGuna) ? r.dahGuna.toLocaleString('en-MY') : '—';
            const had = Number.isSafeInteger(r.had) ? r.had.toLocaleString('en-MY') : '—';
            setSemasa(r.kiraDari); setUbah(false);
            setHasil(r.cara === 'tunggu'
                ? `Count reset: ${guna} / ${had} credits so far. Usage before the customer's first reading is added the next time their browser reads credits (after they press Open Flow).`
                : `Recounted: ${guna} / ${had} credits used since ${papar(r.kiraDari)}.`);
            onSaved?.();
        } catch (e) { setRalat(e?.message || 'Not saved.'); }
        finally { setSedang(false); }
    };

    return (
        <div>
            <p className="s-kv__lab">Count credits from</p>
            {!ubah ? (
                <div className="s-kv__box">
                    {semasa ? papar(semasa) : <span className="s-dim">{uid ? 'Needs the server update to be deployed' : 'No SESAAT account linked'}</span>}
                    {semasa && uid && (
                        <span style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
                            <Btn size="sm" variant="ghost" onClick={() => jalan(semasa)} disabled={sedang}>{sedang ? 'Recounting…' : 'Recount'}</Btn>
                            <Btn size="sm" variant="ghost" onClick={buka} disabled={sedang}>Change</Btn>
                        </span>
                    )}
                </div>
            ) : (
                <div className="s-kv__box" style={{ flexWrap: 'wrap', gap: 8 }}>
                    <input className="s-inp" type="datetime-local" value={nilai} max={keInput(Date.now())}
                        onChange={(e) => setNilai(e.target.value)} disabled={sedang} style={{ flex: '1 1 200px', minWidth: 0 }} />
                    <span style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
                        <Btn size="sm" variant="quiet" onClick={() => setUbah(false)} disabled={sedang}>Cancel</Btn>
                        <Btn size="sm" onClick={() => jalan(nilai ? new Date(nilai).getTime() : NaN)} disabled={sedang}>{sedang ? 'Recounting…' : 'Reset & recount'}</Btn>
                    </span>
                </div>
            )}
            {ralat && <p className="s-kv__hint" style={{ color: 'var(--s-stop)' }}>{ralat}</p>}
            {hasil && <p className="s-kv__hint" style={{ color: 'var(--s-ink)' }}>{hasil}</p>}
            <p className="s-kv__hint">
                Only usage from this time until the access end date counts toward the customer's limit. Recount clears the count and rebuilds it from this time.
            </p>
        </div>
    );
}
